import axios from 'axios';
import {
    LOGIN_SUCCESS,
    LOGIN_FAIL,
    LOGOUT,
    USER_LOADED_SUCCESS,
    USER_LOADED_FAIL,
    AUTHENTICATED_SUCCESS,
    AUTHENTICATED_FAIL,
    LOADING_WATCHLIST_SUCCESS,
    LOADING_WATCHLIST_FAIL,
    RESET_PASSWORD_SUCCESS,
    RESET_PASSWORD_FAIL,
} from './types';
import { auth } from '../firebase';

const API_URL = process.env.REACT_APP_API_URL;

export const checkAuthenticated = () => async dispatch => {
    // Check if a Firebase user is currently signed in
    if (typeof window === 'undefined') {
        dispatch({
            type: AUTHENTICATED_FAIL
        });
        return;
    }

    const user = auth.currentUser || (localStorage.getItem('user') && JSON.parse(localStorage.getItem('user')));
    if (user) {
        dispatch({
            type: AUTHENTICATED_SUCCESS
        });
    } else {
        dispatch({
            type: AUTHENTICATED_FAIL
        });
    }
};

export const loadUser = () => async dispatch => {
    // Load user from Firebase Auth or localStorage
    let user = auth.currentUser;
    if (!user && localStorage.getItem('user')) {
        user = JSON.parse(localStorage.getItem('user'));
    }
    if (user) {
        dispatch({
            type: USER_LOADED_SUCCESS,
            payload: user
        });
    } else {
        dispatch({
            type: USER_LOADED_FAIL
        });
    }
};

export const logoutUser = () => dispatch => {
    dispatch({ type: LOGOUT });
};

// Replace googleLogin to use only Firebase user info (no backend)
export const googleLogin = (firebaseUser) => async dispatch => {
    try {
        localStorage.setItem('user', JSON.stringify(firebaseUser));
        // Optionally, store ID token if needed
        // const idToken = await firebaseUser.getIdToken();
        // localStorage.setItem('access_token', idToken);

        dispatch({
            type: LOGIN_SUCCESS,
            payload: { user: firebaseUser }
        });
        dispatch(loadUser());
        dispatch(loadWatchlist(firebaseUser));
    } catch (err) {
        dispatch({
            type: LOGIN_FAIL
        });
    }
};

export const emailLogin = (firebaseUser) => async dispatch => {
    try {
        localStorage.setItem('user', JSON.stringify(firebaseUser));

        dispatch({
            type: LOGIN_SUCCESS,
            payload: { user: firebaseUser }
        });
        dispatch(loadUser());
        dispatch(loadWatchlist(firebaseUser));
    } catch (err) {
        dispatch({
            type: LOGIN_FAIL
        });
        console.log(err);
    }
};

export const emailRegister = (firebaseUser) => async dispatch => {
    try {
        localStorage.setItem('user', JSON.stringify(firebaseUser));
        dispatch({
            type: 'REGISTER_SUCCESS',
            payload: { user: firebaseUser }
        });
        // Optionally, you can also dispatch loadUser() or loadWatchlist(firebaseUser)
    } catch (err) {
        dispatch({
            type: 'REGISTER_FAIL'
        });
        console.log(err);
    }
};

export const loadWatchlist = (user) => async dispatch => {
    if (!user || !user.uid) return;

    try {
        const config = {
            headers: {
                'Content-Type': 'application/json'
            }
        };
        const res = await axios.get(`${API_URL}/api/watchlistView/?userid=${user.uid}`, config);
        // console.log('Watchlist data:', res.data.savedResults);
        

        // Normalize the payload to always be an array of watchlists
        let watchlists = [];
        if (res.data && res.data.savedResults && Array.isArray(res.data.savedResults)) {
            watchlists = res.data.savedResults;
        } else if (Array.isArray(res.data)) {
            watchlists = res.data;
        }

        dispatch({
            type: LOADING_WATCHLIST_SUCCESS,
            payload: watchlists,
        });
    } catch (err) {
        dispatch({
            type: LOADING_WATCHLIST_FAIL,
        });
        console.log(err);
    }
};

